import { render, staticRenderFns } from "./Archive.vue?vue&type=template&id=346a19f6&scoped=true&"
import script from "./Archive.vue?vue&type=script&lang=js&"
export * from "./Archive.vue?vue&type=script&lang=js&"
import style0 from "./Archive.vue?vue&type=style&index=0&id=346a19f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "346a19f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VCard,VPagination})
